export const BASE_URL = process.env.REACT_APP_API_URL ?? '';
export const OKTA_AUTH_URL = process.env.REACT_APP_OKTA_AUTH_URL ?? '';
export const OKTA_LOGOUT_URL = process.env.REACT_APP_OKTA_LOGOUT_URL ?? '';
